import React from 'react';
import { Shield } from 'lucide-react';
import { formatInr } from '../lib/formatInr';

const SOURCE = {
  customer_booking: 'Customer — new booking (T&C popup)',
  customer_edit: 'Customer — edited booking',
  agent_edit_customer_otp: 'Agent edit — customer OTP',
  partner_edit_customer_otp: 'Partner edit — customer OTP',
};
const fmt = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '—');

export const InsuranceConsentPanel = ({ booking }) => {
  const bags = booking?.luggage_details?.bags || [];
  const c = booking?.insurance_consent;
  const log = booking?.consent_log || [];
  return (
    <div className="p-3 border-2 border-black font-mono text-xs" data-testid="admin-insurance-consent">
      <div className="font-bold uppercase flex items-center gap-1 mb-2"><Shield size={12} className="text-[#00C853]" />Insurance &amp; consent</div>
      <div className="space-y-1">
        {bags.map((b, i) => (
          <div key={i} className="flex justify-between gap-2" data-testid={`admin-insurance-bag-${i}`}>
            <span>Bag #{i + 1} · {(b.bag_type || '').toUpperCase()}</span>
            {b.insurance_opted ? (
              <span className="font-bold text-[#00A844]">INSURED · {formatInr(b.declared_value)} cover · +{formatInr((Math.min(Number(b.declared_value) || 0, 10000)) * 0.04)}</span>
            ) : (
              <span className="text-gray-600">NOT INSURED (declined)</span>
            )}
          </div>
        ))}
        <div className="flex justify-between gap-2 pt-1 border-t border-dashed border-gray-300">
          <span>Insurance premium</span><b>{formatInr(booking?.insurance_premium)}</b>
        </div>
      </div>
      <div className="mt-2 pt-2 border-t border-dashed border-gray-300" data-testid="admin-consent-latest">
        {c ? (
          <>
            <div>Consent: <b className={c.terms_accepted ? 'text-[#00A844]' : 'text-red-700'}>{c.terms_accepted ? 'ACCEPTED' : 'NOT CONFIRMED'}</b> · {fmt(c.at)}</div>
            <div className="text-gray-600">Via: {SOURCE[c.source] || c.source}{c.ip ? ` · IP ${c.ip}` : ''}</div>
          </>
        ) : (
          <div className="text-gray-600">Consent not recorded (booking made before consent tracking).</div>
        )}
        {log.length > 1 && (
          <details className="mt-1">
            <summary className="cursor-pointer text-gray-700" data-testid="admin-consent-history-toggle">History ({log.length})</summary>
            <ul className="mt-1 space-y-0.5">
              {log.slice().reverse().map((e, i) => (
                <li key={i}>{fmt(e.at)} — {SOURCE[e.source] || e.source}: {e.insured_bags?.length || 0} insured, {e.declined_bags?.length || 0} declined, premium {formatInr(e.premium_total)}</li>
              ))}
            </ul>
          </details>
        )}
      </div>
    </div>
  );
};
